import axios from "axios";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Product from "../components/Product";
import { useLocation } from "react-router-dom";
import { mobile } from "../responsive";
import { BASE_URL } from "../requestMethods";

const FilterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Filter = styled.div`
  margin: 20px 0;
  ${mobile({ width: "0px 20px", display: "flex", flexDirection: "column" })}
`;

const FilterText = styled.span`
  font-size: 20px;
  font-weight: 600;
  margin-right: 20px;
  ${mobile({ marginRight: "0px" })}
`;

const Select = styled.select`
  padding: 10px;
  margin-right: 20px;
  ${mobile({ margin: "10px 0px" })}
`;
const Option = styled.option``;

const Category = () => {
  const location = useLocation();
  const cat = location.pathname.split("/")[2];
  const [category, setCategory] = useState([]);

  const [filters, setFilters] = useState({});
  const [sort, setSort] = useState("default");
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);

  const handleFilters = (e) => {
    const value = e.target.value;
    setFilters({
      ...filters,
      [e.target.name]: value,
    });
  };

  useEffect(() => {
    const getCategory = async () => {
      try {
        const res = await axios.get(`${BASE_URL}products?category=${cat}`);
        setCategory(res.data);
      } catch (err) {
        console.log("Error is", err);
      }
    };
    getCategory();
  }, [cat]);

  useEffect(() => {
    cat &&
      setFilteredProducts(
        products.filter((item) =>
          Object.entries(filters).every(([key, value]) =>
            item[key].includes(value)
          )
        )
      );
  }, [products, cat, filters]);

  return (
    <>
      <section className="product-list mt-1">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="product-filters">
                <FilterContainer>
                  <Filter>
                    <FilterText>Filter Products:zzzzzzzzz</FilterText>
                    <Select name="color" onChange={handleFilters}>
                      <Option>Color</Option>
                      <Option>white</Option>
                      <Option>black</Option>
                      <Option>red</Option>
                      <Option>blue</Option>
                      <Option>yellow</Option>
                      <Option>green</Option>
                    </Select>
                    <Select name="size" onChange={handleFilters}>
                      <Option>Size</Option>
                      <Option>XS</Option>
                      <Option>S</Option>
                      <Option>M</Option>
                      <Option>L</Option>
                      <Option>XL</Option>
                    </Select>
                  </Filter>
                  <Filter>
                    <Select onChange={(e) => setSort(e.target.value)}>
                      <Option value="default">Default</Option>
                      <Option value="ascending">Price (Low to High)</Option>
                      <Option value="descending">Price (High to Low)</Option>
                    </Select>
                  </Filter>
                </FilterContainer>
              </div>
              <div className="product-listing mt-1">
                <div className="product-grid grid-4">
                  {category.map((item) => (
                    <Product item={item} key={item.id} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Category;
